import ProratedRentCalculator from './ProratedRentCalculator';

export default ProratedRentCalculator;
